module.exports = __webpack_public_path__ + "img/walk-q7n-1.39e4484f.png";